import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = ({ className }: Props) => (
  <svg
    data-ffid="img-hamburger-icon"
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="mask0_2517_9627" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0">
      <rect className={className} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_2517_9627)">
      <path
        d="M3.5 17.6342V16.1345H20.5V17.6342H3.5ZM3.5 12.7497V11.2497H20.5V12.7497H3.5ZM3.5 7.86498V6.36523H20.5V7.86498H3.5Z"
        className="fill-[#333] dark:fill-white"
      />
    </g>
  </svg>
);

export default Icon;
